import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { customMoldedColDefs, customMoldedAddHeaders, customMoldedRowData } from './tables/customMolded';

@Component({
    selector: 'app-custom-molded-rubber-products',
    templateUrl: './custom-molded-rubber-products.component.html',
    styleUrls: [
        './custom-molded-rubber-products.component.scss',
    ],
    standalone: false
})
export class CustomMoldedRubberProductsComponent implements OnInit {
  customMoldedColDefs = customMoldedColDefs;
  customMoldedAddHeaders = customMoldedAddHeaders;
  customMoldedRowData = customMoldedRowData;
  
  constructor(
    private meta: Meta,
    private title: Title,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Custom Molder Rubber", "data-type": "string"});
    this.title.setTitle(`Custom Molded Rubber | Marco Sealing Solutions`);
  }

  ngOnInit() {
  }

}
